module.exports = __webpack_public_path__ + "static/media/otros.2a3bdb27.svg";